/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/${encodeURIComponent(request.path['deviceId'] as any)}/challenge`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/{deviceId}/challenge',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Generate a challenge nonce for a registered trusted device. Forwards to authx-auth-api with the email extracted from the token in the request body.
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    deviceId: string
  }
  body: {
    /**
     * JWT issued by login-beef. The user email is extracted from it.
     */
    token: string
  }
}

export interface Response {
  /**
   * Cryptographically secure random UUID used by the client to sign with its private key.
   */
  nonce: string
  /**
   * UUID identifying this challenge request.
   */
  challengeId: string
  /**
   * ISO 8601 timestamp when the challenge expires. ISO 8601 date-time.
   */
  expiresAt: string
  /**
   * UUID of the trusted device.
   */
  deviceId: string
}

